import React from 'react';
import ReactDOM from 'react-dom';
import { Paywall, StiggProvider, StiggProviderProps, PaywallProps } from '@stigg/react-sdk';

let sharedConfig = {
  apiKey: undefined,
  baseUri: undefined,
  customerId: undefined,
  theme: undefined,
  locale: undefined,
};

/**
 * @param {StiggProviderProps} config
 */
const Stigg = (config) => {
  if (!config.apiKey) {
    throw new Error('Cannot initialize Stigg, apiKey is missing');
  }

  sharedConfig = config;
  return {
    /**
     * @param {PaywallProps} paywallConfig
     */
    Paywall: (paywallConfig) => {
      return {
        mount: (selector) => {
          ReactDOM.render(
            <StiggProvider {...sharedConfig}>
              <Paywall {...paywallConfig} />
            </StiggProvider>,
            document.querySelector(selector),
          );

          return () => {
            ReactDOM.unmountComponentAtNode(document.querySelector(selector));
          };
        },
      };
    },
  };
};

export default Stigg;
